import { validateContentReference } from '@gitbook/app-content-refs';
import { Schema } from '@gitbook/slate';

import { BLOCK_IF, BLOCK_OPENAPI } from '../types';
import { replaceEditableApiBlocks } from './replaceEditableApiSchema';

const validateOpenApiRef = validateContentReference(['file', 'url', 'openapi']);
/*
 * Schema to validate OpenAPI blocks.
 */
export const schema = Schema.create({
    validations: [replaceEditableApiBlocks],
    blocks: {
        [BLOCK_OPENAPI]: {
            parent: { objects: ['document', 'block'], types: [undefined, BLOCK_IF] },
            isVoid: true,
            data: {
                path: (data: any) => typeof data === 'string',
                method: (data: any) => typeof data === 'string',
                ref: (data: any) => validateOpenApiRef(data),

                // whether block is expanded by default
                expanded: (data: any) => data === undefined || typeof data === 'boolean',

                // @deprecated Per-block width is no longer consumed by the editor or renderer
                fullWidth: (fullWidth) =>
                    typeof fullWidth === 'undefined' || typeof fullWidth === 'boolean',
            },
        },
    },
});
